import { CREATE_GRADE, GET_GRADE, GRADE_REQUEST, DELETE_GRADE, UPDATE_GRADE, GRADE_REQUEST_FAILURE } from "../types";

const initialState = {
  grades: [],
  loading: false,
  error: null,
};

const gradeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GRADE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_GRADE: {
      return {
        ...state,
        grades: [...action.payload],
        loading: false,
        error: null
      }
    }
    case CREATE_GRADE:
      return {
        ...state,
        grades: [action.payload, ...state.grades],
        loading: false,
        error: null
      };
    case UPDATE_GRADE:
      const gradesData = state.grades.slice(0);
      const uIndex = gradesData.findIndex((data) => data.id === action.payload.id);
      gradesData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        grades: [ ...gradesData ],
        loading: false,
        error: null
      };
    case DELETE_GRADE:
      const grades = state.grades?.slice(0);
      const index = grades.findIndex((data) => data.id === action.id);
      if (index > -1) {
          grades.splice(index, 1);
      }
      return {
        ...state,
        grades: [...grades],
        loading: false,
        error: null
      }
    case GRADE_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default gradeReducer